import GameUtil from "../../../../utility/game_util";
import LanguageManager from '../../../../manager/language_manager';
import NodePoolUtil from '../../../longhudou/module/node_pool_util';
import { GoldRoomInfo } from "./goldentrance_matching_view";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ItemInfo extends cc.Component {

    //入场区间
    @property(cc.RichText)
    joinArea: cc.RichText = null;
    @property(cc.Label)
    joinAreaLabel: cc.Label = null;
    @property(cc.Label)
    preBet: cc.Label = null;
    @property(cc.Label)
    bet: cc.Label = null;
    //底注
    @property(cc.Label)
    baseScore: cc.Label = null;

    @property(cc.Node)
    commonNode : cc.Node = null;


    arr1: string = ""//"<color=#E7FAFF><size=30>";
    arr2: string = ""//"</c></size>";
    arr3: string = ""//"<color=#E2F041><size=36>";
    arr4: string = ""//"</size></color>";

    private getScoreArea(data : GoldRoomInfo){

        let min = Number(data.minJoinCoin)>Math.floor(Number(data.minJoinCoin))? GameUtil.currencyFormatting(data.minJoinCoin, -1):GameUtil.currencyFormatting(data.minJoinCoin,0);
        if ( !data.maxJoinCoin || data.maxJoinCoin == 0) {
            return min + "+";
        }

        let max = Number(data.minJoinCoin)>Math.floor(Number(data.maxJoinCoin))? GameUtil.currencyFormatting(data.maxJoinCoin, -1):GameUtil.currencyFormatting(data.maxJoinCoin,0);;

        return min + "-" + max;
    }

    //"<color=#E7FAFF><size=26>เดิมพัน:</c></size><color=#E2F041><size=34>1000</size></color>"
    updateBullBullItem(data: GoldRoomInfo) {
        var baseScore = Number(data.baseScore)>Math.floor(Number(data.baseScore))?GameUtil.currencyFormatting(data.baseScore, -1):GameUtil.currencyFormatting(data.baseScore, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string =  this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }
    updateNinePointItem(data: GoldRoomInfo) {
        //cc.log("九点数据:",data);
        var baseScore = Number(data.smallBet)>Math.floor(Number(data.smallBet))?GameUtil.currencyFormatting(data.smallBet, -1):GameUtil.currencyFormatting(data.smallBet, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }
    updateBlackJack(data: GoldRoomInfo) {
        var baseScore = Number(data.smallBet)>Math.floor(Number(data.smallBet))?GameUtil.currencyFormatting(data.smallBet, -1):GameUtil.currencyFormatting(data.smallBet, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;  
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
        //var maxBet = Number(data.bigBet)>Math.floor(Number(data.bigBet))?GameUtil.currencyFormatting(data.bigBet, -1):GameUtil.currencyFormatting(data.bigBet, 0);
        //this.maxBet.string = this.arr1 + LanguageManager.t("Public_game_BetMax") + this.arr2 + this.arr3 + maxBet + this.arr4;
    }
    updateBP(data: GoldRoomInfo) {
        var baseScore = Number(data.baseScore)>Math.floor(Number(data.baseScore))?GameUtil.currencyFormatting(data.baseScore, -1):GameUtil.currencyFormatting(data.baseScore, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }

    updateK9(data: GoldRoomInfo) {
        var baseScore = Number(data.baseScore)>Math.floor(Number(data.baseScore))?GameUtil.currencyFormatting(data.baseScore, -1):GameUtil.currencyFormatting(data.baseScore, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }

    updateDZPKItem(data: GoldRoomInfo, xindex: number) {
        var smallBet = Number(data.smallBet)>Math.floor(Number(data.smallBet))?GameUtil.currencyFormatting(data.smallBet, -1):GameUtil.currencyFormatting(data.smallBet, 0);
        var bigBet = Number(data.bigBet)>Math.floor(Number(data.bigBet))?GameUtil.currencyFormatting(data.bigBet, -1):GameUtil.currencyFormatting(data.bigBet, 0);
        if (xindex == 1) {

            var preBet = Number(data.preBet)>Math.floor(Number(data.preBet))?GameUtil.currencyFormatting(data.preBet, -1):GameUtil.currencyFormatting(data.preBet, 0);
            var data1 = '{0}/{1}'.format(smallBet,bigBet);
            this.bet.string = this.arr1 + LanguageManager.t("dz_blind") + this.arr2 + this.arr3 + data1 + this.arr4;
            var data2 = preBet;
            this.preBet.string = this.arr1 + LanguageManager.t("dz_qianzhu") + this.arr2 + this.arr3 + data2 + this.arr4;
            this.preBet.node.color = data.labelColor[data.index]
            this.bet.node.color = data.labelColor[data.index]
        }
        else if (xindex == 0) {
            var data1 = '{0}/{1}'.format(smallBet, bigBet);
            this.joinAreaLabel.string = this.arr1 + LanguageManager.t("dz_blind") + this.arr2 + this.arr3 + data1 + this.arr4;
            this.joinAreaLabel.node.color = data.labelColor[data.index]
        }
        this.baseScore.string = Number(data.minJoinCoin)>Math.floor(Number(data.minJoinCoin))?GameUtil.currencyFormatting(data.minJoinCoin, -1):GameUtil.currencyFormatting(data.minJoinCoin,0);
        this.baseScore.font = data.labelFont[data.index]
        this.commonNode.active = false;
    }

    updateQ2(data: GoldRoomInfo){

        var baseScore = Number(data.baseScore)>Math.floor(Number(data.baseScore))?GameUtil.currencyFormatting(data.baseScore, -1):GameUtil.currencyFormatting(data.baseScore, 0);
        this.baseScore.string = baseScore;
        this.baseScore.font = data.labelFont[data.index]
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }

    updateSlot(data : GoldRoomInfo){
        this.baseScore.font = data.labelFont[data.index]
        this.baseScore.string = data.playRule.minMultiple + "/" + data.playRule.maxMultiple ;
        this.joinAreaLabel.string = this.arr3 + this.getScoreArea(data) + this.arr4;
        this.joinAreaLabel.node.color = data.labelColor[data.index]
        this.commonNode.active = true;
    }
}